import { useEffect } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { init, teardown } from './LegacyShortcutsBridge.js';

/**
 * ShortcutsProvider will react to changes to the state located at
 * views.app.shortcutsContexts.
 */
export default function ShortcutsProvider() {
	const { isLicensed } = useSessionData();
	useEffect(() => {
		if (!isLicensed) return;

		init();

		return () => {
			teardown();
		};
	}, [isLicensed]);

	return null;
}
